import { datadogRum } from '@datadog/browser-rum';

const { VITE_STAGE } = process.env;
export class DefaultError extends Error {
  constructor({ error, name, message, title } = {}) {
    super(error);

    /* istanbul ignore next -- @preserve */
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }

    this.name = name ?? DefaultError.name;
    this.title = title ?? 'Error';
    this.message = message ?? error?.message ?? 'Unexpected error';
    this.keyword = '';
    this.response = {
      status: '',
      statusText: '',
      data: '',
      config: { url: '' }
    };
    this.cause = error;

    this.#logError();
  }

  static get name() {
    return 'DefaultError';
  }

  #logError() {
    console.error(
      `${this.stack} \n\n:: caused by :: \n\n ${this.cause?.stack}`
    );
    /* istanbul ignore next -- @preserve */
    if (VITE_STAGE !== 'test') {
      datadogRum.addError(this, {
        stack: this.stack
      });
    }
  }

  toJson() {
    return JSON.parse(JSON.stringify(this, Object.getOwnPropertyNames(this)));
  }
}
